// extracted by mini-css-extract-plugin
export default {"animations":"CSXcib","field-appear":"_Vr4I0","fieldAppear":"_Vr4I0"};